import { Route, Routes } from 'react-router-dom';
import { MenusPage } from './MenusPage';
import { MenuItemsPage } from './MenuItemsPage';

export const MenuPageRoot = () => (
  <Routes>
    <Route path='/:menuID' element={<MenuItemsPage />} />
    <Route path='*' element={<MenusPage />} />
  </Routes>
);
